import React from 'react';
import { Text, Flex, Box, Stack, Circle } from '@tapresearch/ui/components';
import { BarDatum, BarTooltipProps } from '@nivo/bar';
import { useColorScheme } from '../../../project/longitudinal-results';
import { TapAnswer } from 'app/javascript/bundles/insights_platform/api';

export interface CustomCrossTabTooltipProps {
  barData: BarTooltipProps<BarDatum>;
  answersById: Record<string, TapAnswer['attributes']>;
}

export function CustomCrossTabTooltip({
  barData,
  answersById,
}: CustomCrossTabTooltipProps) {
  const colors = useColorScheme();

  const { id: hoveredAnswerId, data: answerValues } = barData;

  return (
    <Box
      rounded="md"
      boxShadow="2xl"
      bg="white"
      overflow="hidden"
      py={4}
      px={2}
    >
      <Box
        pb={2}
        px={2}
        mb={2}
        color="gray.700"
        fontSize="md"
        fontWeight="medium"
      >
        {barData.indexValue}
      </Box>
      <Stack spacing={2}>
        {Object.entries(answersById).map(([answerId, answerAttributes], i) => {
          const isHoveredOption = hoveredAnswerId === answerId.toString();

          if (!answerValues[answerId]) {
            return null;
          }

          return (
            <Flex
              key={i}
              justify="space-between"
              align="center"
              color="gray.600"
              py={2}
              px={3}
              rounded="md"
              fontSize="sm"
              fontWeight="normal"
              {...(isHoveredOption && {
                fontWeight: 'semibold',
                color: 'gray.800',
                border: '1px solid',
                borderColor: colors[i],
              })}
            >
              <Flex align="center">
                <Circle
                  as={Flex}
                  alignItems="center"
                  bgColor={colors[i]}
                  h={3}
                  w={3}
                  mr={2}
                />
                {answerAttributes.option_text}
              </Flex>
              <Flex fontWeight="bold" color="gray.800" ml={4}>
                <Text>{answerValues[answerId].toString() + '%'}</Text>
                <Text ml={1}>
                  ({answerValues[answerId.toString() + '_total']})
                </Text>
              </Flex>
            </Flex>
          );
        })}
      </Stack>
    </Box>
  );
}
